<template>
    <div>
        <el-dialog v-if="isShow" v-el-drag-dialog :title="$tx('hygl.components.change', '变更')" :visible.sync="isShow" :close-on-click-modal="false" width="1000px">
            <el-form ref="changeForm" :rules="rules" :model="replayVo" style="margin: 10px 0px; text-align: center">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr v-if="radio === '1'" key="radio">
                                    <td class="el-table__cell tdlbl tdw17">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'undertaker'">承办人</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="承办人" rules="required">
                                            <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                <el-input v-model="replayVo.recUser" v-select-dialog="'staff'" type="input" multiple="false" :root-org-code="loginUser.orgCode" name="recUser" :placeholder="$tx('hygl.components.undertakerPlaceholder', '请选择承办人')" :org-id="row.orgFullId.split('-')[1]"></el-input>
                                            </el-tooltip>
                                        </ValidationProvider>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
            <!-- <button v-show="anniu" v-select-dialog="'staff'" class="xzry" multiple="true" :root-org-code="loginUser.orgCode" name="Share"></button> -->
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" :icon="'el-icon-close'" :disabled="doing" @click="close">关 闭</el-button>
                <el-button v-pageBtn-lbl="'submit'" type="primary" :disabled="doing" :icon="'el-icon-check'" @click="SignforConfirm">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    components: {},
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            loginUser: this.$store.getters.loginUser,
            isShow: false,
            replayVo: {},
            radio: '1',
            anniu: false,
            list: {},
            row: {}
        }
    },
    prpos: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        crow: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {},
    watch: {
        radio(val) {
            if (val === '1') {
                this.replayVo.cause = ''
            } else {
                this.replayVo.recUser = ''
            }
        },
        isShow(val) {
            if (!val) {
                this.replayVo = {}
                this.radio = '1'
            }
        }
    },
    created() {
        // this.$bus.on('changeWform', this.open)
    },
    beforeDestroy() {
        // this.$bus.off('changeWform', this.open)
    },
    mounted() {},
    methods: {
        open(val) {
            this.row = val
            // console.log(555, val)
            // console.log(222, this.crow)
        },
        // 保存
        SignforConfirm() {
            var _this = this
            this.$refs.changeForm.formValidate(async (isOk) => {
                if (!_this.replayVo.recUser && _this.radio === '1') {
                    _this.$alert(_this.$tx('hygl.message.needUndertaker', '承办人是必须的'), _this.$tx('common.operationTip', '操作提示'), {
                        type: 'warning'
                    })
                    return
                }
                // var $scope = _this.$vnode.context
                // _this.vo.cause = _this.replayVo.cause
                _this.row.qsDate = moment().format('YYYY-MM-DD HH:mm:ss')
                _this.row.status = 2
                _this.row.qsStatus = 1
                // if (_this.radio === '1') {
                //     _this.vo.status = 2
                //     _this.vo.qsStatus = 1
                // } else {
                // // this.data = this.form1
                //     _this.vo.status = 1
                //     _this.vo.qsStatus = 2
                // }
                _this
                    .$http({
                        method: 'PUT',
                        url: '/dbgl/recive/update',
                        data: _this.row
                    })
                    .then((res) => {
                        console.log(999, res)
                        if (res.code === 'success') {
                            _this.isShow = false
                            _this.replayVo = {}
                            // // 结束流程
                            // $scope.btnSubmitClick('Submit', saveCallback => {
                            //     if (saveCallback) {
                            //         window.close()
                            //     }
                            // })

                            _this.$message.success(res.message)
                        } else {
                            _this.$message.error(res.message)
                        }
                    })
            })
        },
        close() {
            this.isShow = false
            this.replayVo = {}
        },

        onSelectStaffCompleted(selectNodes, attr) {
            console.log('选择人', selectNodes)
            let name = ''
            let ids = ''
            let dept = ''
            let deptId = ''
            // const list = []
            for (var i = 0; i < selectNodes.length; i++) {
                if (name !== '') name += '、'
                if (ids !== '') ids += '、'
                if (dept !== '') dept += '、'
                if (deptId !== '') deptId += '、'
                name += selectNodes[i].name
                ids += selectNodes[i].personId
                dept += selectNodes[i].orgFullName.split('-')[1]
                deptId += selectNodes[i].orgFullId.split('-')[1]
            }
            this.$set(this.replayVo, 'recUser', name)
            this.$set(this.replayVo, 'recUserId', ids)
            this.$set(this.replayVo, 'recDept', dept)
            this.$set(this.replayVo, 'recDeptId', deptId)
            // eslint-disable-next-line no-redeclare
            for (var i = 0; i < selectNodes.length; i++) {
                const newobj = {}
                const obj = selectNodes[i]
                newobj.recUserId = obj.id
                newobj.recUser = obj.name
                newobj.recPersonId = obj.personId
                this.list = newobj
            }
            console.log('选到的', this.list)
            this.row.recUserId = this.list.recUserId
            this.row.recUser = this.list.recUser
            this.row.recPersonId = this.list.recPersonId
            this.row.recDept = this.replayVo.recDept
            this.row.recDeptId = this.replayVo.recDeptId
            console.log(777, this.row)
        }
    }
}
</script>

<style scoped lang="scss">
.lastButton {
    font-size: var(--portalFontSize12);
}
</style>
